import {
  Typography,
  IconButton,
  Card,
  Button,
} from '@mui/material';
import DeleteIcon from '../../../Assets/images/svg/dar_delete.svg';
import { SKILL_CERT_PROFILE } from '../../../Constants/strings';
import PropTypes from 'prop-types';


const AwardCard = ({ award, handleViewAward, handleDeleteAward, hasAccess }) => {
  return (
    <div className="award-profile-swipe">
      <div className="award-carousel-mobile-item">
        <Card>
          <Typography className="award-name">
            {award.award_name.length > 20
              ? `${award.award_name.substring(0, 20)}...`
              : award.award_name}
          </Typography>
          <Typography className="award-year">
            {award.year}
          </Typography>
          <div className="award-view-btn-div">
            <Button
              className="award-view-btn"
              variant="outlined"
              onClick={handleViewAward(award)}
            >
              {SKILL_CERT_PROFILE.VIEW}
            </Button>
          </div>
        </Card>
        {hasAccess('delete') && (
          <IconButton
            className="award-delete-icon"
            onClick={handleDeleteAward(award)}
          >
            <img src={DeleteIcon} alt="Delete" />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default AwardCard;

AwardCard.propTypes = {
  award: PropTypes.any.isRequired,
  handleViewAward: PropTypes.func.isRequired,
  handleDeleteAward: PropTypes.func.isRequired,
  hasAccess: PropTypes.func.isRequired,
};
